module.exports = __webpack_public_path__ + "static/shapes-601ae446cc210fe189a6b72b734a15ba.png";